import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFireIcon = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#pet__paint0_linear_21105_27062)",
			d: "M15.9395 13.1508C15.5289 16.0791 12.7725 18 9.93361 18C6.70437 18 4.58794 15.6618 4.1587 13.4085C3.72946 11.1552 4.1587 9.82433 5.59603 8.51245C6.57135 7.62226 8.291 6.09956 9.11232 2C14.7332 6.87262 16.3502 10.2225 15.9395 13.1508Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#pet__paint1_linear_21105_27062)",
			d: "M6.13747 11.052C5.60165 13.2508 6.70777 15.073 8.14689 15.8161C11.5347 16.737 13 14.022 13 11.6135C13 9.67579 12.1812 8.56528 10.2078 6C10.8776 9.32439 10.2078 11.2876 8.86821 11.2876C7.53684 10.6055 8.2671 9.01028 7.91502 8.56528C7.42554 8.9841 6.38476 10.0678 6.13747 11.052Z"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "pet__paint0_linear_21105_27062",
			x1: 10,
			x2: 10,
			y1: 2,
			y2: 18,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFE75D" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FF4314"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "pet__paint1_linear_21105_27062",
			x1: 9.5,
			x2: 9.5,
			y1: 9,
			y2: 16,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FFEDC7"
			})]
		})] })
	]
});
const ForwardRef = forwardRef(SvgFireIcon);
export default ForwardRef;
